
export enum OfflineReceiptType {
  Receipt = 'Receipt',
  CompanyInvoice = 'CompanyInvoice',
}
